export function isValidDate(date) {
    const dateRegEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegEx.test(date)) {
        return false;
    }
    const [year, month, day] = date.split("-").map(Number);
    const dateObj = new Date(year, month - 1, day);
    return dateObj.getFullYear() === year && dateObj.getMonth() === month - 1 && dateObj.getDate() === day;
}
export function isBefore(firstDateString, secondDateString) {
    const firstDate = new Date(firstDateString);
    const secondDate = new Date(secondDateString);
    return firstDate <= secondDate;
}
export function isBetween(dateString, minDate, maxDate) {
    return (!minDate || isBefore(minDate, dateString)) && (!maxDate || isBefore(dateString, maxDate));
}
//# sourceMappingURL=dateUtils.js.map